import React from 'react';
import { Monitor } from 'lucide-react';

export function ConnectMobileRestrictedPanel() {
    return (
        <div className="cw-mobile-restricted cw-fade-in-up h-100 d-flex flex-column justify-content-center">
            <div className="cw-mobile-restricted-card text-center mx-auto w-100">
                <div
                    className="cw-icon-circle mb-4 bg-light text-muted mx-auto"
                    style={{ width: 64, height: 64 }}
                >
                    <Monitor size={30} aria-hidden="true" />
                </div>
                <h4 className="fw-bold text-dark mb-2">Desktop required</h4>
                <p className="text-muted fs-7 mb-0 px-2">
                    Adastra Connect panel can only be used on desktop or laptop.
                    Please open Adastra Connect on a computer to sign in and receive calls.
                </p>
            </div>
        </div>
    );
}
